import React from 'react';
import ReactToPrint from 'react-to-print';
import {
  Button,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableRow } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Print from '@material-ui/icons/Print';
import { format } from 'date-fns';
import classnames from 'classnames';
import ArquivoXMLApi from '../../api/ArquivoXMLApi';

const styles = theme => ({
  root: {
    paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    margin: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  direita: {
    textAlign: 'right',
    width: '50%',
  },
  div: {
    paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    textAlign: 'center',
  },
  typography: {
    paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
    paddingBottom: theme.spacing(2),
    textAlign: 'center',
  },
  cellCancelada: {
    backgroundColor: '#f2dede',
  },
  fontTableLink: {
    fontSize: 12,
    cursor: 'pointer',
    color: 'blue',
    textDecoration: 'underline'
  },
});

class ComponentToPrint extends React.Component {
  arquivoXMLApi = new ArquivoXMLApi();
  handleClickDownLoad = async (protocolo) => {
    let conteudoXml = await this.arquivoXMLApi.abrirXml(protocolo.txtObjetoGed);

    const url = window.URL.createObjectURL(new Blob([conteudoXml]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', protocolo.nomArquivo);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  }
  render () {
    const { protocolo, classes } = this.props;
    return (
      <Paper className={classes.root} elevation={1}>
        <Typography variant='h6' className={classes.typography}>
          Dados do Protocolo
        </Typography>
        <Table padding={'default'}>
          <TableBody>
            {(protocolo.valTotalProcessado === undefined || protocolo.valTotalProcessado === 0) &&
            <TableRow>
              <TableCell className={classes.direita}>Número da Senha de Autorizacao:</TableCell>
              <TableCell>{protocolo.nomOperadora}</TableCell>
            </TableRow>}
            <TableRow>
              <TableCell className={classes.direita}>Número do Protocolo:</TableCell>
              <TableCell>{protocolo.numProtocolo}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.direita}>Nome do Prestador:</TableCell>
              <TableCell>{protocolo.nomPrestador}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.direita}>CNPJ do Prestador:</TableCell>
              <TableCell>{protocolo.cnpjCpjPrestador}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.direita}>Quantidade de Guias:</TableCell>
              <TableCell>{protocolo.qtdGuias}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.direita}>Tipo das Guias:</TableCell>
              <TableCell>{protocolo.nomTipoGuia}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.direita}>Data de Recebimento:</TableCell>
              <TableCell>{format(new Date(protocolo.dtaRecebimento), 'DD/MM/YYYY')}</TableCell>
            </TableRow>
            {protocolo.valTotalProcessado !== undefined && protocolo.valTotalProcessado !== 0 &&
            <TableRow>
              <TableCell className={classes.direita}>Valor Processado do Lote:</TableCell>
              <TableCell>{new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(protocolo.valTotalProcessado)}</TableCell>
            </TableRow>}
            <TableRow>
              <TableCell className={classnames(classes.direita, protocolo.indCancelado === 'S' ? classes.cellCancelada : classes.direita)}>Situação do Lote:</TableCell>
              {protocolo.indCancelado === 'S'
                ? <TableCell className={classes.cellCancelada}>CANCELADO</TableCell>
                : <TableCell>{protocolo.situacao}</TableCell>}
            </TableRow>
            {protocolo.nomArquivo != '-' &&
            <TableRow>
              <TableCell className={classes.direita}>Nome do arquivo:</TableCell>
              <TableCell className={classes.fontTableLink} onClick={() => this.handleClickDownLoad(protocolo)}>{protocolo.nomArquivo}</TableCell>
            </TableRow>
            }
          </TableBody>
        </Table>
      </Paper>
    );
  }
}

class PrintComponentProtocolo extends React.Component {
  render () {
    const { classes, protocolo } = this.props;
    return (
      <div>
        <ComponentToPrint
          ref={el => (this.componentRef = el)}
          protocolo={protocolo}
          classes={classes} />
        <ReactToPrint
          trigger={() =>
            <div className={classes.div}>
              <Button
                variant='contained'
                color='primary'
                className={classes.button}
                href='#'>
                <Print className={classes.icon} /> Imprimir / Salvar
              </Button>
            </div>}
          content={() => this.componentRef}
        />
      </div>
    );
  }
}
export default withStyles(styles)(PrintComponentProtocolo);
